export default "__VITE_ASSET__Cz9mbruj__"